import React from 'react';

interface RecentSearchesProps {
  onSearch: (searchTerm: string, source: string, searchOptions: any, shouldUpdateUrl: boolean) => void;
  storedSearches: Array<string>;
}

export const RecentSearches = ({ onSearch, storedSearches }: RecentSearchesProps) => {
  return (
    <>
      {storedSearches.map(searchTerm => (
        <li key={searchTerm}>
          <a
            href={'/search?query=' + searchTerm}
            onClick={e => {
              e.preventDefault();
              onSearch(searchTerm, 'click recent search', {}, false);
            }}
          >
            {searchTerm}
          </a>
        </li>
      ))}
    </>
  );
};
